// extracted by mini-css-extract-plugin
export default {"avatar":"NZDbm0B","avatar--clickable":"sNJ_bOv"};